import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class ErrorLogRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    get(errorLogId: number): Observable<Core.ErrorLogModel> {
        return this.httpGet(`/api/errorlog/${errorLogId}`);
    }

    getViaGuid(errorLogGuid: string): Observable<Core.ErrorLogModel> {
        return this.httpGet(`/api/errorlog/${errorLogGuid}`);
    }

    getList(searchModel: Core.ErrorLogInfoSearchModel): Observable<Compliance.QueryResultModel<Core.ErrorLogInfoModel>> {
        return this.httpPost('/api/errorlog', searchModel);
    }

    getRowIds(searchModel: Core.ErrorLogInfoSearchModel): Observable<Compliance.QueryResultModel<number>> {
        return this.httpPost('/api/errorlog/rowIds', searchModel);
    }

    startExport(exportModel: Core.ErrorLogExportModel): Observable<number> {
        return this.httpPost(`/api/errorLog/export`, exportModel);
    }

    getExport(longRunningProcessId: number): Observable<HttpResponse<Blob>> {
        const options = {
            observe: 'response',
            responseType: 'blob'
        };
        return this.httpGet(`/api/errorLog/export/${longRunningProcessId}`, options);
    }
}
